"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePageDimensionsContext = exports.withPageDimensionsContext = void 0;

var react_1 = __importStar(require("react"));

var lodash_1 = require("lodash");

var PageDimensionsContext = react_1.createContext({
  width: 0,
  height: 0,
  size: 'sm'
});

var mapBreakpointsSize = function mapBreakpointsSize(breakpoints, width) {
  if (breakpoints === void 0) {
    breakpoints = {};
  }

  return Object.keys(breakpoints).slice().reverse().find(function (item) {
    return width >= breakpoints[item];
  }) || 'sm';
};

var usePageDimensionsContext = function usePageDimensionsContext() {
  return react_1.useContext(PageDimensionsContext);
};

exports.usePageDimensionsContext = usePageDimensionsContext;

var getDimensions = function getDimensions(breakpoints) {
  if (typeof window !== 'undefined') {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      size: mapBreakpointsSize(breakpoints, window.innerWidth)
    };
  }

  return {
    width: 0,
    height: 0,
    size: 'sm'
  };
};

var PageDimensionsProvider = function PageDimensionsProvider(_a) {
  var children = _a.children,
      breakpoints = _a.breakpoints;

  var _b = react_1.useState(getDimensions(breakpoints)),
      dimensions = _b[0],
      setDimensions = _b[1];

  react_1.useEffect(function () {
    var handleResize = function handleResize() {
      setDimensions(getDimensions(breakpoints));
    };

    window.addEventListener('resize', lodash_1.throttle(handleResize, 100));
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return react_1.default.createElement(PageDimensionsContext.Provider, {
    value: dimensions
  }, children);
};
/**
 * Adds a context which provides the current viewport size as well as the
 * breakpoint to which it maps.
 *
 * @param breakpoints A list of breakpoints to define the mapping.
 *
 * @return HOC which wraps a component with the context provider.
 */


var withPageDimensionsContext = function withPageDimensionsContext(_a) {
  var breakpoints = _a.breakpoints;
  return function (Component) {
    return function (props) {
      return react_1.default.createElement(PageDimensionsProvider, {
        breakpoints: breakpoints
      }, react_1.default.createElement(Component, __assign({}, props)));
    };
  };
};

exports.withPageDimensionsContext = withPageDimensionsContext;
exports.default = PageDimensionsProvider;